/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Load_MoreInputs */

const en_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

const de_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr laden`)
};

const fr_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger plus`)
};

const es_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

const it_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica altro`)
};

const nl_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer laden`)
};

const pl_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załaduj więcej`)
};

const fi_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa lisää`)
};

const da_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæs mere`)
};

const sv_common_load_more = /** @type {(inputs: Common_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda mer`)
};

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Common_Load_MoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_load_more = /** @type {((inputs?: Common_Load_MoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Load_MoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_load_more(inputs)
	if (locale === "fr") return fr_common_load_more(inputs)
	if (locale === "es") return es_common_load_more(inputs)
	if (locale === "it") return it_common_load_more(inputs)
	if (locale === "nl") return nl_common_load_more(inputs)
	if (locale === "pl") return pl_common_load_more(inputs)
	if (locale === "fi") return fi_common_load_more(inputs)
	if (locale === "da") return da_common_load_more(inputs)
	if (locale === "sv") return sv_common_load_more(inputs)
	return en_common_load_more(inputs)
});